import "../../assets/scss/leaflet.css";

import {
  getContactPageTitle,
  getContactService,
  getTiTleContactUs,
} from "../../services/pagesRequestServices";
import { useCallback, useEffect, useRef, useState } from "react";

import Form from "../../ui-kits/form/Form";
import { Icon } from "@mui/material";
import markerSvg from "../../assets/media/marker.svg";
import { mergeObjectByKey } from "../../utilities/merge";
import { sendContactUs } from "../../services/contactUsServices";
import { statusesOfForm } from "../../utilities/consts/models";
import styled from "styled-components";
import { useSnackbar } from "notistack";
import HtmlContent from "../../components/general/misc/HtmlContent";
import { toPersianNumber } from "../../utilities/persianNumber";
import Sochial from "./Sochial";

const contactUsInfo = [
  {
    code: "1052",
    icon: "icon-phone",
    title: "تلفن",
  },
  {
    code: "1054",
    icon: "icon-fax",
    title: "فکس",
  },
  {
    code: "1055",
    icon: "icon-mobile",
    title: "همراه",
  },
  {
    code: "1053",
    icon: "icon-envelope",
    title: "ایمیل",
  },
  {
    code: "1056",
    icon: "icon-location",
    title: "آدرس",
  },
];

const newsletterFormFields = [
  {
    key: "last_name",
    label: "نام و نام خانوادگی",
    name: "last_name",
    isRequired: true,
    defaultValue: null,
    type: "name",
  },
  {
    key: "mobile",
    label: "موبایل",
    name: "mobile",
    isRequired: true,
    defaultValue: null,
    type: "tel",
  },
  {
    key: "email",
    label: "ایمیل",
    name: "email",
    isRequired: true,
    defaultValue: null,
    type: "mail",
  },
  {
    key: "title",
    label: "موضوع درخواست",
    name: "title",
    isRequired: true,
    defaultValue: null,
    type: "text",
  },
];

const L = require("leaflet");

const ContactUs = () => {
  const [statusForm, changeStatusForm] = useState(statusesOfForm.filling);
  const { enqueueSnackbar } = useSnackbar();
  const mapContainer = useRef();
  const [contactData, changeContactData] = useState({});
  const [titleContact, setTitleContact] = useState({});
  const [pageTitle, changePageTitle] = useState(null);
  const [mapLocation, setMapLocation] = useState([0, 0]);
  const [map, setMap] = useState(null);

  const getPageTitle = useCallback(() => {
    return getContactPageTitle().then((res) => changePageTitle(res));
  }, []);

  const getContactData = useCallback(() => {
    return getContactService().then((res) =>
      changeContactData(mergeObjectByKey(res, contactUsInfo, "code"))
    );
  }, []);

  const getTiTle = useCallback(() => {
    return getTiTleContactUs().then((res) => setTitleContact(res));
  }, []);

  useEffect(() => {
    getTiTle();
    getContactData();
    getPageTitle();
  }, [getContactData, getPageTitle, getTiTle]);

  const onSubmit = (data) => {
    changeStatusForm(statusesOfForm.sending);
    sendContactUs(data)
      .then(() => {
        enqueueSnackbar("درخواست شما با موفقیت ارسال شد.", {
          variant: "success",
        });
        changeStatusForm(statusesOfForm.success);
      })
      .catch(() =>
        enqueueSnackbar("ارسال درخواست با خطا مواجه شد.", { variant: "error" })
      )
      .finally(() => {
        changeStatusForm(statusesOfForm.filling);
      });
  };

  function onClickPin() {
    window.open("https://goo.gl/maps/3LzHVMxDebHoCQb29", "_blank");
  }
  useEffect(() => {
    contactData?.details?.forEach((item) => {
      if (item.id === 80) {
        let numberCreate = item.content.slice(3, item.content.length - 4);
        let splited = numberCreate.split(",");
        let oneNumber = splited[0];
        let twoNumber = splited[1];
        let updatedMapLocation = [+oneNumber, +twoNumber.split(" ")[1]];
        setMapLocation(updatedMapLocation);
      }
    });
  }, [contactData]);

  useEffect(() => {
    if (
      L &&
      mapContainer &&
      mapLocation &&
      !mapContainer.current.hasChildNodes()
    ) {
      const leafletMap = L.map(mapContainer.current, { zoomControl: false });
      setMap(leafletMap);
    }
  }, [mapContainer, mapLocation]);

  useEffect(() => {
    if (map) {
      map.setView(mapLocation, 16);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "",
        minZoom: 10,
      }).addTo(map);
      const greenIcon = L.icon({
        iconUrl: markerSvg,
        iconSize: [28, 30],
        iconAnchor: [9, 24],
      });
      L.marker(mapLocation, { icon: greenIcon })
        .addTo(map)
        .on("click", onClickPin);
    }
  }, [map, mapLocation]);

  console.log(titleContact.title);

  return (
    <Styles>
      <div className="col-12 col-lg-8 px-0 pb-3 px-md-2">
        <div className="row mx-0 border border-1 border-blue rounded p-3 p-md-4 text-14">
          <div className="col-12 col-lg-8 px-0">
            <div className="row m-0">
              {(contactData.details || []).map((item, index) => {
                if (item.id <= 56 || item.id <= 52) {
                  return (
                    <div
                      key={item.code + "info"}
                      className={`col-12 ${
                        index < contactData.details.length - 1
                          ? "col-md-6"
                          : "col-md-12"
                      } ${
                        item.title === "آدرس"
                          ? "address px-0 mb-4 pt-2"
                          : "px-0 mb-4 pt-2 d-flex align-items-center"
                      } `}
                    >
                      <Icon className={`${item.icon} text-green text-14`} />
                      <ContactRow className="me-3 d-flex">
                        <HtmlContent rawHtml={item.title} />
                        &nbsp;:&nbsp;
                        <HtmlContent rawHtml={toPersianNumber(item.content)} />
                      </ContactRow>
                    </div>
                  );
                }
                //  else if (item.id === 80) {

                // }
                else {
                  return null;
                }
              })}
            </div>
          </div>
          <StyledMapContainer className="col-12 col-lg-4">
            <div>
              <div id="mapid" ref={mapContainer} />
            </div>
          </StyledMapContainer>
        </div>
      </div>
      <div className="col-12 col-lg-8 px-0 px-md-2">
        <Sochial header={titleContact.title || null} />
      </div>
      <div className="col-12 col-lg-8 px-0 mb-5 px-md-2">
        <p className="text-14 text-md-18 line-height-2x px-0 mt-3 text-white">
          {pageTitle?.title}
        </p>
        <Form
          fields={newsletterFormFields}
          onSubmit={onSubmit}
          isSending={statusForm === statusesOfForm.sending}
          isSuccess={statusForm === statusesOfForm.success}
        />
      </div>
    </Styles>
  );
};
export default ContactUs;

const Styles = styled.div`
  width: calc(100% - 6rem);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;

  .address {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100% !important;
  }
`;

const ContactRow = styled.span`
  p {
    display: inline-block;
    margin-bottom: 0;
  }
`;

const StyledMapContainer = styled.div`
  > div {
    width: 100%;
    height: 100%;
    min-height: 180px;
    border-radius: 10px;
    overflow: hidden;

    @media (max-width: 992px) {
      height: 200px;
    }

    #mapid {
      width: 100%;
      height: 100%;
    }
  }
`;
